<template>
  <Multiselect
    :modelValue="selectedLocation"
    :options="locations"
    label="name"
    track-by="id"
    :placeholder="placeholder"
    :allow-empty="allowEmpty"
    :show-labels="false"
    class="location-select"
    @update:modelValue="$emit('update:modelValue', $event ? $event.id : null)"
  >
    <template #noResult>No locations match your search.</template>
    <template #noOptions>No locations available.</template>
  </Multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';

export default {
  name: 'LocationSelect',
  components: { Multiselect },
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
    locations: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Search location…',
    },
    allowEmpty: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  computed: {
    selectedLocation() {
      return this.locations.find((location) => location.id === this.modelValue) || null;
    },
  },
};
</script>
